import { toast } from 'sonner';

const ALLOW_STEPS =
  'Click the padlock icon left of the website address -> Microphone -> Allow, then reload the page and log in to WebRTC again.';

export const micBlockedToast = (description = ALLOW_STEPS) =>
  toast.error('WebRTC login blocked: microphone not allowed', { id: 'webrtc-mic-blocked', description, duration: 20000 });

export async function ensureMicAllowed(): Promise<boolean> {
  const md = typeof navigator !== 'undefined' ? navigator.mediaDevices : undefined;
  if (!md?.getUserMedia) {
    micBlockedToast('This browser cannot use the microphone here. Open the panel over https in Chrome or Edge.');
    return false;
  }
  try {
    const stream = await md.getUserMedia({ audio: true });
    stream.getTracks().forEach((t) => t.stop());
    return true;
  } catch (e: any) {
    const name = e?.name;
    if (name === 'NotFoundError' || name === 'OverconstrainedError') {
      micBlockedToast('No microphone found. Plug in a headset or microphone, then log in to WebRTC again.');
      return false;
    }
    if (name === 'NotAllowedError' || name === 'PermissionDeniedError' || name === 'SecurityError') {
      micBlockedToast();
      return false;
    }
    return true;
  }
}

export function watchMicRevoked(onDenied: () => void) {
  navigator.permissions
    ?.query({ name: 'microphone' as PermissionName })
    .then((p) => {
      p.addEventListener('change', () => {
        if (p.state === 'denied') onDenied();
      });
    })
    .catch(() => {
    });
}
